
/**
 * Validates Slack integration settings
 * @param webhookUrl The Slack incoming webhook URL
 * @param slackToken The Slack bot token
 * @returns Error message if validation fails, null if valid
 */
export const validateSlackSettings = (webhookUrl: string, slackToken: string): string | null => {
  if (!webhookUrl) {
    return "Webhook URL is required";
  }
  
  if (!slackToken) {
    return "Slack token is required";
  }
  
  if (!webhookUrl.startsWith('https://hooks.slack.com/services/')) {
    return "Invalid webhook URL format. It should start with 'https://hooks.slack.com/services/'";
  }
  
  if (!slackToken.startsWith('xoxb-')) {
    return "Invalid Slack token format. Bot tokens should start with 'xoxb-'";
  }
  
  return null;
};
